export {
  setSkinId
}

function setSkinId (id) {
  return dispatch => {
    return dispatch({ skinId: id, type: 'SET_SKIN_ID' })
  }
}
